import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { UtilitiesModule } from '../../utilities/utilities.module';
import { FiNumericValidatorModule } from '../../components/validators/numeric-validator/numeric-validator.module';
import { DataFieldEditComponent } from './data-field-edit.component';
import { DataFieldEditNameComponent } from './name/name.component';
import { DataFieldEditDescriptionComponent } from './description/description.component';
import { DataFieldEditClusterComponent } from './cluster/cluster.component';
import { DataFieldEditAreasComponent } from './areas/areas.component';
import { DataFieldEditBusinessAreasComponent } from './business-areas/business-areas.component';
import { DataFieldEditPhoneNumberComponent } from './phone-number/phone-number.component';
import { DataFieldEditEmailAddressComponent } from './email-address/email-address.component';
import { DataFieldEditAddressComponent } from './address/address.component';
import { DataFieldEditCustomTextComponent } from './custom-text/custom-text.component';
import { DataFieldEditCustomNumericComponent } from './custom-numeric/custom-numeric.component';
import { DataFieldEditCustomCalendarComponent } from './custom-calendar/custom-calendar.component';
import { DataFieldEditCustomPreSetOptionComponent } from './custom-pre-set-options/custom-pre-set-options.component';
import { DataFieldEditPasswordComponent } from './password/password.component';
import { DataFieldEditActiveComponent } from './active/active.component';
import { DataFieldEditRolesComponent } from './roles/roles.component';
import { DataFieldEditTagsComponent } from './tags/tags.component';
import { DataFieldEditUnitsComponent } from './units/units.component';
import { DataFieldEditLanguagesComponent } from './languages/languages.component';
import { ComponentsModule } from '@fi-app/components/components.module';
import { FiChangePasswordTooltipModule } from '@fi-app/components/change-password-tooltip/change-password-tooltip.module';
import { FiDataFieldEditOrgNrComponent } from '@fi-app/data-field/data-field-edit/org-nr/org-nr.component';
import { MatInputModule } from '@angular/material/input';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiComponentOutletModule } from '@fi-shared/fi-directives/fi-component-outlet/fi-component-outlet.module';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiUserResetPasswordComponent } from '@fi-app/data-field/data-field-edit/password/reset-password/reset-password.component';
import { FiContactsModule } from '@fi-shared/fi-contacts/fi-contacts.module';
import { FiNameInputModule } from '@fi-app/shared/fi-name-input/fi-name-input.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatCheckboxModule,
        MatFormFieldModule,
        FiAppTextSharedModule,
        UtilitiesModule,
        FiNumericValidatorModule,
        ComponentsModule,
        FiChangePasswordTooltipModule,
        MatInputModule,
        SelectSearchModule,
        FiComponentOutletModule,
        FiErrorMessageModule,
        MatRadioModule,
        MatDividerModule,
        MatIconModule,
        MatButtonModule,
        FiContactsModule,
        FiNameInputModule,
    ],
    declarations: [
        DataFieldEditComponent,
        DataFieldEditNameComponent,
        DataFieldEditDescriptionComponent,
        DataFieldEditClusterComponent,
        DataFieldEditAreasComponent,
        DataFieldEditBusinessAreasComponent,
        DataFieldEditPhoneNumberComponent,
        DataFieldEditEmailAddressComponent,
        DataFieldEditAddressComponent,
        DataFieldEditPasswordComponent,
        FiUserResetPasswordComponent,
        DataFieldEditActiveComponent,
        DataFieldEditRolesComponent,
        DataFieldEditTagsComponent,
        DataFieldEditUnitsComponent,
        DataFieldEditLanguagesComponent,
        DataFieldEditCustomTextComponent,
        DataFieldEditCustomNumericComponent,
        DataFieldEditCustomCalendarComponent,
        DataFieldEditCustomPreSetOptionComponent,
        FiDataFieldEditOrgNrComponent,
    ],
    exports: [DataFieldEditComponent],
})
export class DataFieldEditModule {}
